import commonEndpoints from 'config/api/common';
import prepareDataForSelect from 'services/prepareDataForSelect';

const serviceAreaDictionary = {
  url: commonEndpoints.serviceAreas(),
  dataParser: (data, result) => ({ ...result, service_area: prepareDataForSelect(data) }),
};

export default serviceAreaDictionary;
